import React, { useEffect, useState } from "react";
import "./index.css";
import env from "../../../../../../config/env";
import toast from "react-hot-toast";
import CommonModal from "../../../ResetContext/components/DumpModal";
import Select from "react-select";
import ContactToSupportModal from "../../../../../../components/ContactToSupportModal";
import { useUsersContext } from "../../../../../../context/usersContext";
import { useAddTeamMember } from "../../../../../../queries/settingsAccount";
import { Input } from "components/ui/input";
import { Button } from "components/ui/button";
import { Loader2 } from "lucide-react";

const Modal = ({ isOpen, onClose, children }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  return (
    <>
      {isOpen && (
        <CommonModal
          title="Add Team Member"
          isOpen={isOpen}
          onClose={onClose}
          showAlert={false}
        >
          {children}
        </CommonModal>
      )}
    </>
  );
};

// Example usage in another component
const AddUserModal = ({
  isModalOpen,
  justCloseIt,
  getLocationUsers = () => { },
  user,
  userActiveLocation,
  activeplans,
  locationUsers,
  setActiveTab,
  setPricingHeading,
}) => {
  const [processing, setProcessing] = useState(false);
  const addTeamMember = useAddTeamMember();

  // prompt payload states
  const [userName, setUserName] = useState();
  const [userEmail, setUserEmail] = useState();
  const [userRole, setUserRole] = useState();

  // error status
  const [userNameError, setUserNameError] = useState(null);
  const [userEmailError, setUserEmailError] = useState(null);
  const [userRoleError, setUserRoleError] = useState(null);
  const [openLimitModal, setOpenLimitModal] = useState(false)
  const { products, isHighestPlan } = useUsersContext()

  const resetAddUserForm = () => {
    setUserName("");
    setUserEmail("");
    setUserRole("");
  };
  const handleClose = () => {
    justCloseIt();
  };
  const [userLimitReached, setuserLimitReached] = useState(false);
  const handleAddUserSubmit = async () => {
    setProcessing(true);
    // Reset all previous errors
    setUserNameError(null);
    setUserEmailError(null);
    setUserRoleError(null);
    let hasError = false;
    // Validate the required fields
    if (!userName) {
      setUserNameError("User Name is required");
      hasError = true;
    }
    if (!userEmail) {
      setUserEmailError("Email is required");
      hasError = true;
    }

    if (!userRole) {
      setUserRoleError("Role is required");
      hasError = true;
    }

    if (hasError) {
      setProcessing(false);
      return;
    }

    if (
      activeplans &&
      locationUsers.length >= parseInt(activeplans.user_limit) &&
      userActiveLocation.type === "premium"
    ) {
      setuserLimitReached(true);
      return;
    }

    if (
      userActiveLocation.type === "free" &&
      locationUsers.length >= userActiveLocation?.number_of_team_member
    ) {
      setuserLimitReached(true);
      return;
    }

    try {
      const response = await addTeamMember.mutateAsync({
        userName: userName,
        email: userEmail,
        role: userRole,
        agency_id: userActiveLocation?.agency_id,
        activeLocation: [userActiveLocation?.id],
        password: "password",
        user_id: Math.random(),
      });
      setProcessing(false);

      if (response) {
        toast.success("User added successfully");
        handleClose();
        resetAddUserForm();
        getLocationUsers();
      }
    } catch (err) {
      toast.error(err.response.data.message);
      setProcessing(false);
    }
  };

  useEffect(() => {
    const activePlan = products?.find(item => item?.activePlan === true)
    if (userLimitReached) {
      setTimeout(() => {
        if (userActiveLocation?.type === 'free' || (!activePlan?.isenable_account && !activePlan?.developer_plan) || isHighestPlan())
          setOpenLimitModal(true)
        else {
          setActiveTab("Pricing");
          setPricingHeading("Upgrade to add more team members");
        }
      }, 500);
    }
  }, [userLimitReached]);

  // Role options for the dropdown
  const roleOptions = [
    {
      value: "admin",
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <span>Admin</span>
          <span className="text-muted-foreground" style={{ fontSize: 14, margin: 0 }}>
            Create and Edit AI Agents
          </span>
        </div>
      ),
      description: "Create and Edit AI Agents",
    },
    {
      value: "user",
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          <span>User</span>
          <span className="text-muted-foreground" style={{ fontSize: 14, margin: 0 }}>
            Use AI Agents
          </span>
        </div>
      ),
      description: "Use AI Agents",
    },
  ];

  // Custom styles for react-select to match the image
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: 8,
      borderColor: "hsl(var(--border))",
      minHeight: 58,
      boxShadow: state.isFocused ? "0 0 0 2px hsl(var(--border))" : "none",
      fontSize: 16,
      fontWeight: 400,
      paddingLeft: 8,
      background: "hsl(var(--background))",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "hsl(var(--foreground))",
      fontSize: 16,
      fontWeight: 400,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: 12,
      marginTop: 4,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      padding: 0,
      overflow: "hidden",
      background: "hsl(var(--popover))",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "hsl(var(--muted))"
        : state.isFocused
          ? "hsl(var(--accent))"
          : "hsl(var(--background))",
      color: "hsl(var(--foreground))",
      fontSize: 16,
      fontWeight: 400,
      padding: "20px 24px",
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid hsl(var(--border))",
      cursor: "pointer",
      justifyContent: "space-between",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "hsl(var(--foreground))",
      fontSize: 18,
      fontWeight: 400,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "hsl(var(--foreground))",
      paddingRight: 16,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  // Find the selected option object for react-select
  const selectedRoleOption = roleOptions.find((opt) => opt.value === userRole);

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={justCloseIt}>
        {userLimitReached && <p>User Limit Reached</p>}
        <div>
          <div style={{ position: "relative" }}>
            <div style={{ marginBottom: "20px" }}>
              <Input
                type="text"
                name="username"
                placeholder="Name"
                value={userName}
                onChange={(e) => {
                  setUserName(e.target.value);
                  setUserNameError(null);
                }}
              />
              {userNameError && (
                <small className="text-destructive">{userNameError}</small>
              )}
            </div>
            <div style={{ marginBottom: "20px" }}>
              <Input
                type="text"
                name="name@email.com"
                placeholder="User Email"
                value={userEmail}
                onChange={(e) => {
                  setUserEmail(e.target.value);
                  setUserEmailError(null);
                }}
              />
              {userEmailError && (
                <small className="text-destructive">{userEmailError}</small>
              )}
            </div>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <Select
                options={roleOptions}
                value={selectedRoleOption || null}
                onChange={(option) => {
                  setUserRole(option.value);
                  setUserRoleError(null);
                }}
                placeholder="Select role"
                styles={customSelectStyles}
                isSearchable={false}
                components={{
                  // Remove react-select indicator separator
                  IndicatorSeparator: () => null,
                }}
              />
              {userRoleError && (
                <small className="text-destructive">{userRoleError}</small>
              )}
            </div>
            <Button
              type="button"
              className="w-full"
              disabled={processing}
              onClick={handleAddUserSubmit}
            >
              {processing && <Loader2 className="animate-spin" />}
              Save Changes
            </Button>
          </div>
        </div>
      </Modal>
      <ContactToSupportModal isOpen={openLimitModal} onClose={() => setOpenLimitModal(false)} />
    </div>
  );
};

export default AddUserModal;
